export const pdfViwerEvents = {
  added: "added_pdf",
  showed: "showed_pdf",
  deleted: "deleted_pdf",
};
